import type { ProductKeys } from '../../constants/product-keys';
import type { FireAnalyticsEvent } from '../../types';

export type TrackAvailableProductsProps = {
	availableProducts: ProductKeys[];
	searchSessionId?: string | null;
};

export const onTrackAvailableProducts = ({
	availableProducts,
	searchSessionId,
}: TrackAvailableProductsProps): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'availableProducts',
	actionSubject: 'searchPage',
	attributes: {
		additionalAttributes: {
			experienceName: 'search-page',
			availableProducts,
			availableProductsCount: availableProducts.length,
			searchSessionId,
		},
	},
});
